import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"
import errorNoRepLight from "@images/error/errorNoRepLight.svg"
import { BoxPlanningContent } from "@modules/boxPlanning/components/boxPlanningContent"
import { CalendarProvider } from "@modules/calendar/context/calendarContext"
import { word } from "@modules/core/utils/i18n"
import dayjs from "dayjs"
import { ErrorBoundary } from "react-error-boundary"
import { useLocation } from "react-router"

export function BoxPlanningPage() {
  const location = useLocation() as { state?: { selectedDate?: string } }

  return (
    <CalendarProvider
      initialDate={dayjs(location.state?.selectedDate).startOf("day")}
      defaultDisplayDetailedEvents={false}
      defaultView="dayGridWeek"
      isUndated={false}
      isWeekTemplate={false}
      hasHours={true}
    >
      <ErrorBoundary fallback={<BoxPlanningPageError />}>
        <BoxPlanningContent />
      </ErrorBoundary>
    </CalendarProvider>
  )
}

// TODO REFACTO TO 404
export function BoxPlanningPageError({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      className={cn("flex h-120 min-h-full w-full flex-col items-center justify-center gap-2", className)}
      {...props}
    >
      <Text fontStyle="BM" className="text-textDefault-heading">
        {word("global.error.norep")}
      </Text>
      <img src={errorNoRepLight} />
      <Text fontStyle="BM" className="text-textDefault-caption">
        {word("global.error.somethingGoneWrong")}
      </Text>
    </div>
  )
}
